module.exports = __webpack_public_path__ + "static/media/active-minutes-video.cf967db8.mp4";